export const APP_ROUTES_INDEX = '/'
export const APP_ROUTES_LOGIN = '/login'
export const APP_ROUTES_FORGOT_PASSWORD = '/forgot-password'
export const APP_ROUTES_RESET_PASSWORD = '/reset-password'
export const APP_ROUTES_UNLOCK_ACCOUNT = '/unlock-account'
export const APP_ROUTES_LANDING = '/landing'
export const APP_ROUTES_DASHOARD = '/dashboard'
export const APP_ROUTES_STAFF = '/staff'
export const APP_ROUTES_INVITATION = '/invitation/accept'
export const APP_ROUTES_PATIENT = '/patients'
export const APP_ROUTES_INVENTORY_EQUIPMENT = '/inventory'
export const APP_ROUTES_INVENTORY_EQUIPMENT_DETAIL = '/inventory/:detail'
export const APP_ROUTES_PERMISSION = '/role'
export const APP_ROUTES_PRODUCT_MODULES = '/product-modules'
export const APP_ROUTES_DEPARTMENT = '/department'
export const APP_ROUTES_FACILITY = '/facility'
export const APP_ROUTES_SUPPLIER = '/supplier'
export const APP_ROUTES_LOCATION = '/location'
export const APP_ROUTES_SHIFT = '/shift'
export const APP_ROUTES_AUDIT = '/audit'
export const APP_ROUTES_SCHEDULE = '/schedule'
export const APP_ROUTES_APPOINTMENT = '/appointment'
export const APP_ROUTES_APPOINTMENT_SETUP = '/appointment/setup'
export const APP_ROUTES_DRUG = '/drug'
export const APP_ROUTES_ROOOM = '/room'
export const APP_ROUTES_PROCEDURE = '/procedure'
export const APP_ROUTES_IMAGING = '/imaging'
export const APP_ROUTES_FORMS = '/forms'
export const APP_ROUTES_ADD_FORMS = '/forms/add'
export const APP_ROUTES_HMO = '/hmo'
export const APP_ROUTES_HMO_PLAN = '/hmo/:id'
export const APP_ROUTES_HMO_PLAN_TARIFF = '/hmo/:id/:planId'
export const APP_ROUTES_LABORATORY = '/lab-test'
export const APP_ROUTES_BED_REQUEST = '/bed-request'
export const APP_ROUTES_CHARGE_ITEMS = '/charge-items'
export const APP_ROUTES_ARCHIVES = '/archives'
export const APP_ROUTES_UNAUTHORIZE = '/unauthorize'

// Unified app routes (no role prefix) – single path per feature
export const APP_ROUTES_APP_WAITLIST = '/waitlist'
export const APP_ROUTES_APP_WAITLIST_DOCTORS = '/waitlist/doctors'
export const APP_ROUTES_APP_WAITLIST_NURSES = '/waitlist/nurses'
export const APP_ROUTES_APP_WAITLIST_RECEPTIONISTS = '/waitlist/receptionists'
export const APP_ROUTES_APP_INTAKE = '/intake'
export const APP_ROUTES_APP_PATIENTS = '/patients'
export const APP_ROUTES_APP_SCHEDULE = '/schedule'
export const APP_ROUTES_APP_BED_REQUEST = '/bed-request'
export const APP_ROUTES_APP_MED_ORDER = '/med-order'
export const APP_ROUTES_APP_MED_ORDERS = '/med-orders'
export const APP_ROUTES_APP_PHARMACY_WORKSPACE = '/pharmacy-workspace'

/** Deep-link into Pharmacy Workspace mock tabs (sidebar → production IA → playground) */
export const pharmacyWorkspaceHref = (pharmTab: string, mode?: 'hospital' | 'community') => {
  const params = new URLSearchParams()
  params.set('pharmTab', pharmTab)
  if (mode) params.set('mode', mode)
  return `${APP_ROUTES_APP_PHARMACY_WORKSPACE}?${params.toString()}`
}
export const APP_ROUTES_APP_DOCUMENT_TEMPLATE = '/document-template'
export const APP_ROUTES_APP_DOCUMENT_TEMPLATE_NEW = '/document-template/new'
export const APP_ROUTES_APP_ENCOUNTERS = '/encounters'
export const APP_ROUTES_APP_ASSIGNED = '/assigned'
export const APP_ROUTES_APP_ADMISSION = '/admission'
export const APP_ROUTES_APP_DRUG_INVENTORY = '/drug-inventory/product-list'
export const APP_ROUTES_APP_PRODUCT_DETAILS = '/drug-inventory/product-details/:productId'
export const APP_ROUTES_APP_DISPENSE = '/dispense'
export const APP_ROUTES_APP_DISPENSE_INPATIENT = '/dispense-inpatient'
export const APP_ROUTES_APP_DISPENSE_OUTPATIENT = '/dispense-outpatient'
export const APP_ROUTES_APP_INTAKE_NEW = '/intake/new/:patientId'
export const APP_ROUTES_APP_PATIENT_CHART_INTAKE = '/patient-chart/:patientId/intake'
export const APP_ROUTES_APP_PATIENT_CHART_INTAKE_ID = '/patient-chart/:patientId/intake/:intakeId'
export const APP_ROUTES_APP_PATIENT_MAR = '/patient-mar/:encounterId/patient/:patientId'
export const APP_ROUTES_APP_LABORATORY = '/laboratory'
export const APP_ROUTES_APP_IMAGING = '/radiology'
export const APP_ROUTES_APP_DIRECTORY = '/directory'
export const APP_ROUTES_APP_CARD = '/card'
export const APP_ROUTES_APP_REPORTS = '/reports'
export const APP_ROUTES_APP_PHARMACY_REPORTS = '/pharmacy-reports'
export const APP_ROUTES_APP_PHARMACIST_REQUISITIONS = '/drug-inventory/requisitions'
export const APP_ROUTES_APP_NURSE_REQUISITIONS = '/requisitions'
export const APP_ROUTES_APP_PHARMACIST_REQUISITIONS_NEW = '/drug-inventory/requisitions/new'
export const APP_ROUTES_APP_REQUISITIONS_NEW = '/requisitions/new'
export const APP_ROUTES_APP_STOCK_TAKE = '/stock-take'
export const APP_ROUTES_USER_VIDEO_GUIDE = '/video-guide'

// Patient chart & encounter (no role prefix)
export const APP_ROUTES_PATIENT_CHART = '/patient-chart'
export const APP_ROUTES_PATIENT_DIRECTORY_DETAILS = '/patient-chart/:patientId'
export const APP_ROUTES_PATIENT_DIRECTORY = '/patient-directory'
export const APP_ROUTES_PATIENT_ENCOUNTERS = '/patient-chart/:patientId/encounters'
export const APP_ROUTES_PATIENT_VITALS = '/patient-chart/:patientId/encounter/:encounterId/rounding/vitals'
export const APP_ROUTES_PATIENT_LAB_RESULTS = '/patient-chart/:patientId/encounter/:encounterId/rounding/lab'
export const APP_ROUTES_PATIENT_IMAGING_RESULTS = '/patient-chart/:patientId/encounter/:encounterId/rounding/imaging'
export const APP_ROUTES_ALLERGY = '/patient-chart/:patientId/allergies'

// Units & billing (no role prefix)
export const APP_ROUTES_UNITS = '/units'
export const APP_ROUTES_DEPARTMENT_ROOM = '/units/room/:detail'
export const APP_ROUTES_BILLING = '/billing'
export const APP_ROUTES_BED = '/units/room/:detail/bed/:id'

// Backward-compatible aliases (same logical route, unified path)
export const APP_ROUTES_DOCTOR_HOME = APP_ROUTES_INDEX
export const APP_ROUTES_DOCTOR_PATIENT_INDEX = APP_ROUTES_APP_PATIENTS
export const APP_ROUTES_NURSE_MAR = '/mar'
export const APP_ROUTES_DOCTOR_PATIENT = APP_ROUTES_APP_PATIENTS
export const APP_ROUTES_DOCTOR_ENCOUNTER_LIST = APP_ROUTES_APP_ENCOUNTERS
export const APP_ROUTES_DOCTOR_WAITLIST = APP_ROUTES_APP_WAITLIST_DOCTORS
export const APP_ROUTES_DOCTOR_INTAKE = APP_ROUTES_APP_INTAKE
export const APP_ROUTES_ADMISSION = APP_ROUTES_APP_ADMISSION
export const APP_ROUTES_DOCTOR_ASSIGNED_PATIENT = APP_ROUTES_APP_ASSIGNED
export const APP_ROUTES_DOCTOR_ENCOUNTER = '/patient-chart/:patientId/encounter/:encounterId'
export const APP_ROUTES_DOCTOR_ADMISSION = APP_ROUTES_PATIENT_DIRECTORY_DETAILS + '/admission'
export const APP_ROUTES_LAB_TECH = APP_ROUTES_APP_LABORATORY
export const APP_ROUTES_RADIO = APP_ROUTES_APP_IMAGING
export const APP_ROUTES_NURSE_BED_REQUEST = APP_ROUTES_APP_BED_REQUEST
export const APP_ROUTES_NURSE_HOME = APP_ROUTES_INDEX
export const APP_ROUTES_NURSE_INTAKE_FORM = APP_ROUTES_APP_PATIENT_CHART_INTAKE
export const APP_ROUTES_NURSE_INTAKE = APP_ROUTES_APP_PATIENT_CHART_INTAKE_ID
export const APP_ROUTES_NURSE_INTAKE_LIST = APP_ROUTES_APP_INTAKE
export const APP_ROUTES_NURSE_PATIENT = APP_ROUTES_APP_PATIENTS
export const APP_ROUTES_NURSE_SCHEDULE = APP_ROUTES_APP_SCHEDULE
export const APP_ROUTES_NURSE_PATIENT_DIRECTORY = APP_ROUTES_PATIENT_DIRECTORY_DETAILS
export const APP_ROUTES_NURSE_PATIENT_ALLERGY = APP_ROUTES_ALLERGY
export const APP_ROUTES_NURSE_WAITLIST = APP_ROUTES_APP_WAITLIST_NURSES
export const APP_ROUTE_PATIENT_MAR = APP_ROUTES_APP_PATIENT_MAR
export const APP_ROUTES_RECP_ADD_INTAKE = APP_ROUTES_APP_INTAKE_NEW
export const APP_ROUTES_RECP_DOC_TEMP = APP_ROUTES_APP_DOCUMENT_TEMPLATE
export const APP_ROUTES_RECP_DOC_TEMP_NEW = APP_ROUTES_APP_DOCUMENT_TEMPLATE_NEW
export const APP_ROUTES_RECP_INTAKE_LIST = APP_ROUTES_APP_INTAKE
export const APP_ROUTES_RECP_WAITLIST = APP_ROUTES_APP_WAITLIST_RECEPTIONISTS
export const APP_ROUTES_PHARMACIST_HOME = APP_ROUTES_INDEX
export const APP_ROUTES_PHARMACIST_DIRECTORY = APP_ROUTES_APP_DIRECTORY
export const APP_ROUTES_PHARMACIST_MED_ORDER = APP_ROUTES_APP_MED_ORDER
export const APP_ROUTES_PHARMACY_WORKSPACE = APP_ROUTES_APP_PHARMACY_WORKSPACE
export const APP_ROUTES_PHARMACIST_CARD = APP_ROUTES_APP_CARD
export const APP_ROUTES_PHARMACIST_MEDICATION_ORDERS = APP_ROUTES_APP_MED_ORDERS
export const APP_ROUTES_PHARMACIST_SCHEDULE = APP_ROUTES_APP_SCHEDULE
export const APP_ROUTES_PHARMACIST_DISPENSE = APP_ROUTES_APP_DISPENSE
export const APP_ROUTES_PHARMACIST_MUR = APP_ROUTES_APP_SCHEDULE
export const APP_ROUTES_PHARMACIST_REPORTS = APP_ROUTES_APP_PHARMACY_REPORTS
export const APP_ROUTES_PHARMACIST_INVENTORY = APP_ROUTES_APP_DRUG_INVENTORY
export const APP_ROUTES_PHARMACIST_PRODUCT_DETAILS = APP_ROUTES_APP_PRODUCT_DETAILS
// export const APP_ROUTES_PHARMACIST_REQUISITION = APP_ROUTES_APP_REQUISITIONS
export const APP_ROUTES_PHARMACIST_NEW_REQUISITION = APP_ROUTES_APP_PHARMACIST_REQUISITIONS_NEW
export const APP_ROUTES_PHARMACIST_STOCK_STAKE = APP_ROUTES_APP_STOCK_TAKE
export const APP_ROUTES_PHARMACIST_DISPENSE_INPATIENT = APP_ROUTES_APP_DISPENSE_INPATIENT
export const APP_ROUTES_PHARMACIST_DISPENSE_OUTPATIENT = APP_ROUTES_APP_DISPENSE_OUTPATIENT
export const APP_ROUTES_PHARMACIST_STOCK_TAKE = APP_ROUTES_APP_STOCK_TAKE
export const APP_ROUTES_LABORATORY_DOC_TEMPLATE = '/laboratory-template'
export const APP_ROUTES_LABORATORY_DOC_TEMPLATE_NEW = '/laboratory-template/new'
export const APP_ROUTES_LABORATORY_DOC_TEMPLATE_PREVIEW = '/laboratory-template/preview'

export const laboratoryDocTemplateEditPath = (templateId: string) =>
  `${APP_ROUTES_LABORATORY_DOC_TEMPLATE_NEW}?id=${encodeURIComponent(templateId)}`

export const APP_ROUTES_REGISTRATION_TEMPLATE = '/registration-template'
export const APP_ROUTES_REGISTRATION_TEMPLATE_NEW = '/registration-template/new'

export const registrationTemplateEditPath = (templateId: string) =>
  `${APP_ROUTES_REGISTRATION_TEMPLATE_NEW}?id=${encodeURIComponent(templateId)}`

export const APP_ROUTES_PUBLIC_REGISTER = '/register/:token'

export const APP_ROUTES_IMAGING_DOC_TEMPLATE = '/imaging-template'
export const APP_ROUTES_IMAGING_DOC_TEMPLATE_NEW = '/imaging-template/new'
export const APP_ROUTES_IMAGING_DOC_TEMPLATE_PREVIEW = '/imaging-template/preview'

export const imagingDocTemplateEditPath = (templateId: string) =>
  `${APP_ROUTES_IMAGING_DOC_TEMPLATE_NEW}?id=${encodeURIComponent(templateId)}`

// Antenatal / maternity (prototype)
export const APP_ROUTES_ANC = '/antenatal'
export const APP_ROUTES_ANC_PATIENT = '/antenatal/patients/:patientId'
export const APP_ROUTES_ANC_VISIT = '/antenatal/patients/:patientId/visits/:visitId'
export const APP_ROUTES_ANC_CARD = '/antenatal/patients/:patientId/card'
export const APP_ROUTES_ANC_LABOUR = '/antenatal/patients/:patientId/labour'
export const APP_ROUTES_ANC_PN_VISIT = '/antenatal/patients/:patientId/postnatal/:visitId'
export const APP_ROUTES_ANC_FORM_TEMPLATES = '/antenatal/form-templates'
